import { render } from "./Forgot.vue?vue&type=template&id=3f7bd9e6&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"

import "./Forgot.vue?vue&type=style&index=0&id=3f7bd9e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f7bd9e6"

export default script